import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PostThumbnail from "./PostThumbnail";
import { fetchPosts } from "../../features/posts/postsSlice";
import Loading from "../ui/Loading";
import Message from "../ui/Message";
function PostContainer() {
  const dispatch = useDispatch();
  const { isLoading, posts, error } = useSelector((state) => state.posts);
  const { filterMode } = useSelector((state) => state.filter);
  const { sortBy } = useSelector((state) => state.sort);

  useEffect(() => {
    dispatch(fetchPosts({ filter: filterMode, sort: sortBy }));
  }, [dispatch, filterMode, sortBy]);

  let content = null;

  if (isLoading) content = <Loading />;
  if (!isLoading && !!error)
    content = (
      <Message text={`Error Fetching Posts. Error Message: ${error}`} />
    );
  if (!isLoading && !error && posts.length === 0)
    content = <Message text={"No Post yet."} />;
  if (!isLoading && !error && posts.length > 0)
    content = posts.map((post) => <PostThumbnail key={post.id} post={post} />);

  return (
    <main className="post-container" id="lws-postContainer">
      {content}
    </main>
  );
}

export default PostContainer;
